export default __webpack_public_path__ + "static/media/huaweiC.a0177faf.jpg";